/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuImage, NeuIcon } from '@neutron/react';

// TODO: Not being used currently
export const AvatarDiv = styled.div`
  padding-top: 5px;
`;

export const EmployeeInfoDiv = styled.div`
  display: flex;
`;

// TODO: Not being used currently
export const EmployeeAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const CompleteIcon = styled(NeuIcon)`
  color: #00558c;
  font-size: 1.25rem;
`;

export const OverdueImg = styled(NeuImage)``;

export const DeptStartContainer = styled.div``;

export const StartDateContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding-right: 2px;
`;
export const NewHireIconContainer = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
`;
